import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {RoutingGroupApiService} from '../../services/api/routing-group/routing-group-api.service';
import * as _ from 'lodash';
import {RoutingGroupsSearchComponent} from '../groups/routing-groups-search/routing-groups-search.component';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {PageEvent} from '@angular/material/paginator';
import {RoutingRuleApiService} from '../../services/api/routing/routing-rule/routing-rule-api.service';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import Search from '../../utils/search';
import {AdminStateEnum} from '../../services/enums/admin-state.enum';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {RoutingRulesDialogComponent} from './routing-rules-dialog/routing-rules-dialog.component';
import {AcDialogService} from 'ac-infra';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {MoveRuleDialogComponent} from './move-rule-dialog/move-rule-dialog.component';
import {RoutingService} from '../services/routing.service';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {RoutingRuleStateTablePipe} from '../pipes/routing-rule-state-pipe';
import {RoleTypeEnum} from '../../services/enums/role-type.enum';

enum RuleErrorType {
  actionsEmpty = 'ruleActionsEmpty',
  invalidPercentage = 'ruleInvalidPercentage',
  invalidCallTrigger = 'ruleInvalidCallTrigger',
  topologyItemEmpty = 'ruleActionTopologyItemEmpty',
  invalidSipHeader = 'ruleInvalidSipHeader',
}
export enum TopologyElementType {
  online_node = 'Online Node',
  offline_node = 'Offline Node',
  online_pcon = 'Online Peer Connection',
  offline_pcon = 'Offline Peer Connection',
  online_voip_peer = 'Online VoIP Peer',
  offline_voip_peer = 'Offline VoIP Peer'
}

export enum TopologyElementPrefix {
  node = 'node_',
  voip_peer = 'voippeer_',
  peer_connection = 'peerConnection_'
}

@Component({
  selector: 'rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss']
})
export class RulesComponent implements OnInit {

  constructor(public dialog: MatDialog,
              private routingService: RoutingService,
              private dialogService: AcDialogService,
              private snackBarService: SnackBarService,
              private userPrivilege: UserPrivilegeService,
              private routingRuleApiService: RoutingRuleApiService,
              private routingGroupApiService: RoutingGroupApiService, private loaderService: LoaderService) { }

  readonly ADMIN_STATE = {
    lock: 'LOCKED',
    unlock: 'UNLOCKED'
  };

  hasSingleSelection = false;
  hasMultipleSelection = false;

  routingGroupsSearchComponent = RoutingGroupsSearchComponent;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  search: any = {};
  data: any;
  isUnauthorized: boolean;
  externalData: any;
  groups: any;
  selection;
  searchData;
  searchTerms: SearchTermDefinitionInf[];
  onlyLockedItemsSelected = false;
  onlyUnlockedItemsSelected = false;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true, width: 200},
    {name: 'rrGroupName', display: 'Group', selected: true, width: 200},
    {name: 'adminState', display: 'Live', selected: true, transformer: RoutingRuleStateTablePipe, width: 200},
    {name: 'testMode', display: 'Test', selected: true, transformer: RoutingRuleStateTablePipe, width: 200},
    {name: 'source', display: 'Source', selected: true, width: 200},
    {name: 'destination', display: 'Destination Description', selected: true, width: 200},
    {name: 'advancedConditions', display: 'Advanced Conditions Description', selected: true, width: 200},
    {name: 'actions', display: 'Actions Description', selected: true, width: 200}
  ];

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.ROUTING);
    this.data = {
      elements: [],
      totalElements: 0
    };
    this.refresh();
  }

  editItem(): void {
    this.routingRuleApiService.getRuleById(this.selection[0].id).then(rule => {
      const newRule = {groupName: rule.name, rule: rule};

      const dialogData: any = {
        ruleData: newRule,
        externalData: this.externalData,
        isEditMode: false
      };

      this.dialogService.open(RoutingRulesDialogComponent, {
        width: 1300,
        height: 700,
        dialogData,
        title: 'Edit Routing Rule',
        onSubmit: () => {
          dialogData.ruleToEdit.id = rule.id;
          dialogData.ruleToEdit.rrGroupId = rule.rrGroupId;

          return this.routingRuleApiService.editExistingRule(dialogData.ruleToEdit).then(value => {
            this.refreshItems();
          }).catch(() => {});
        }
      });
    });
  }

  removeItem(): void {
    const confirmationMessage = `Are you sure you want to delete the rule: "${this.selection[0].name}" ?`;
    const confirmationDialog = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      width: '460px',
      data: {
        message: confirmationMessage
      }
    });

    confirmationDialog.componentInstance.onApply.subscribe(() => {
      this.routingRuleApiService.deleteRules([this.selection[0].id]).then(() => {
        confirmationDialog.close();
        this.snackBarService.display(`"${this.selection[0].name}" successfully deleted`);
        this.refreshItems();
      });
    });
  }

  refresh(): void {
    this.loaderService.showMainContainer();
    this.getExternalData();
    this.getGroups();
  }

  onSelection(selection: any): void {
    this.updateContainerButtons(selection);
    this.selection = selection;
  }

  isSingleSelection(): boolean {
    return this.selection && this.selection.length === 1;
  }

  onSearch(searchObj): void {
    this.search = searchObj;
    this.refreshItems();
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '450px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  moveRule(): void {
    const moveRuleObject = this.routingService.buildMoveRuleObject(this.selection[0]);

    const rules = this.groups.flatMap(group => group.routingRules);

    const ruleId = this.isRuleObject(moveRuleObject.rule) ? moveRuleObject.rule.id : moveRuleObject.rule;
    const sentParameters = {nextId: -1, prevId: -1, originalRuleId: ruleId, groupId: null};

    const dialogData = {
      groups: this.groups,
      rules: this.routingService.populateNames(rules),
      sentParameters,
      selectedGroup: null
    };

    this.dialogService.open(MoveRuleDialogComponent, {
      dialogData,
      title: 'Move Routing Rule',
      onSubmit: () => {
        this.routingRuleApiService.getRuleById(ruleId).then(rule => {
          const returnedRule = this.routingService.createRuleToMove(rule, sentParameters);

          this.routingRuleApiService.moveExistingRule(ruleId, returnedRule).then(data => {
            this.refresh();
          }).catch(() => {});
        });
      }
    });

  }

  duplicateRule(): void {
    this.routingRuleApiService.getRuleById(this.selection[0].id).then(rule => {
      const newRule = {groupName: this.selection[0].name, rule};

      const dialogData: any = {
        ruleData: newRule,
        externalData: this.externalData,
        isEditMode: false
      };

      this.dialogService.open(RoutingRulesDialogComponent, {
        width: 1300,
        height: 700,
        dialogData,
        title: 'Add Routing Rule',
        onSubmit: () => {
          dialogData.ruleToEdit.rrGroupId = rule.rrGroupId;

          if (this.selection[0] !== null && this.selection[0]) {
            dialogData.ruleToEdit.selectedRuleId = this.selection[0].id;
          }

          return this.routingGroupApiService.getGroupById(rule.rrGroupId).then((group) => {
            const addRule = this.routingService.addPrevAndNextIdsToRule(dialogData.ruleToEdit, group);

            return this.routingRuleApiService.addNewRule(addRule).then(() => {
              this.refreshItems();
            });
          });
        }
      });
    });
  }

  toggleLock(adminStatus: string): void {
    const selectionsIds = this.selection.map(selection => selection.id);
    const ruleData = {adminState: this.ADMIN_STATE[adminStatus]};

    this.routingRuleApiService.editExistingRules(selectionsIds, ruleData).then(() => {
      this.refresh();
    }).catch(() => {});
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refreshItems();
  }

  private isRuleObject(rule): any {
    return rule && !_.isNil(rule.id);
  }

  private refreshItems(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    this.routingRuleApiService.getRules(params).then(data => {
      this.data = {
        elements: this.populateFlatRules(data, this.groups, this.externalData),
        totalElements: data.totalElements
      };
      this.loaderService.hideMainContainer();
    });
  }

  private getExternalData(): void {
    this.routingGroupApiService.externalData().then(data => {
      this.externalData = _.cloneDeep(data);
      this.refreshItems();
      this.setSearchOptions();
    });
  }

  private setSearchOptions(): void {
    const discardOptions = [{text: 'True', value: 'True'}, {text: 'False', value: 'True'}];
    const loopbackOptions = [{text: 'True', value: 'True'}, {text: 'False', value: 'True'}];
    const registeredUsersOptions = [{text: 'True', value: 'True'}, {text: 'False', value: 'True'}];
    const isContinueWithNodeTablesOptions = [{text: 'True', value: 'True'}, {text: 'False', value: 'True'}];
    const adminStateOptions = [{text: 'True', value: 'UNLOCKED'}, {text: 'False', value: 'LOCKED'}];
    const qualityOptions = [{text: 'Good', value: 'GOOD'}, {text: 'Fair', value: 'FAIR'}];
    const requestTypeOptions = [{text: 'Call', value: 'CALL'}, {text: 'Register', value: 'REGISTER'}];

    this.searchData = {
      discardOptions,
      registeredUsersOptions,
      isContinueWithNodeTablesOptions,
      adminStateOptions,
      qualityOptions,
      requestTypeOptions
    };

    this.searchTerms = [
      {term: 'adminState', operator: '=', displayName: 'Live', displayValue: Search.getOptionValue(adminStateOptions)},
      {term: 'testMode', operator: '=', displayName: 'Test', displayValue: Search.getOptionValue(adminStateOptions)},
      {term: 'quality', operator: '=', displayName: 'Quality', displayValue: Search.getOptionValue(qualityOptions)},
      {term: 'isRegisteredUsers', operator: '=', displayName: 'Registered Users',
        displayValue: Search.getOptionValue(registeredUsersOptions)},
      {term: 'isDiscard', operator: '=', displayName: 'Discard', displayValue: Search.getOptionValue(discardOptions)},
      {term: 'isLoopback', operator: '=', displayName: 'Loopback', displayValue: Search.getOptionValue(loopbackOptions)},
      {term: 'isContinueWithNodeInternalTables', operator: '=',
        displayName: 'Stop ARM Routing', displayValue: Search.getOptionValue(isContinueWithNodeTablesOptions)},
      {term: 'requestType', operator: '=', displayName: 'Call Type', displayValue: Search.getOptionValue(requestTypeOptions)},
      {term: 'rrGroupName', operator: ':', displayName: 'RR Group Name'},
      {term: 'rrName', operator: ':', displayName: 'RR Name'}
    ];
  }

  private getGroups(): void {
 //   this.loaderService.showMainContainer();
    this.routingGroupApiService.getGroupsSlim().then(groups => {
      this.groups = groups;
     // this.loaderService.hideMainContainer();
    });
  }

  private populateFlatRules(rulesPaging, groupsNames, externalData): any {
    externalData.groupsNames = groupsNames;

    return this.restructureFlatRules(rulesPaging.elements, externalData);
  }

  private restructureFlatRules(rules, dataObject): any {
    const mappedArray = [];

    rules.forEach((rule) => {
      mappedArray.push({
        id: rule.id,
        name: rule.name,
        priority: rule.priority,
        adminState: rule.adminState,
        testMode: rule.testMode,
        rrGroupName: this.getNameById(rule.rrGroupId, dataObject.groupsNames),
        source: this.getRuleSource(rule, dataObject),
        destination: this.getRuleDestination(rule, dataObject),
        advancedConditions: this.getRuleAdvancedConditions(rule, dataObject),
        actions: this.getRuleAction(rule, dataObject)
      });
    });

    return mappedArray;
  }

  private getNameById(id, dataArray): string {
    const resultObj = dataArray.find((group) => {
      return group.id === id;
    });

    return resultObj ? resultObj.name : '';
  }

  private getRuleSource(rule, fetchedItems): any {
    const resultObj = {resultStr: ''};

    this.addField(rule.sourceNodes, resultObj, 'Nodes', fetchedItems.nodes.concat(fetchedItems.offlineNodes));
    this.addField(rule.sourcePcons, resultObj, 'Peer Connections', fetchedItems.pCons.concat(fetchedItems.offlinePCons));
    this.addField(rule.sourceReroutePcons, resultObj, 'Reroute Peer Connections',
      fetchedItems.pCons.concat(fetchedItems.offlinePCons));
    this.addField(rule.sourceUserGroups, resultObj, 'User Groups', fetchedItems.userGroups);
    this.addCustomersField(rule.allSourceCustomers, resultObj, rule.sourceCustomers, fetchedItems.customers);
    this.addAttributeField(rule.sourceRRAttr, resultObj, fetchedItems.prefixGroups);

    return resultObj.resultStr;
  }

  private getRuleDestination(rule, fetchedItems): any {
    const resultObj = {resultStr: ''};

    this.addField(rule.dstUserGroups, resultObj, 'User Groups', fetchedItems.userGroups);
    this.addCustomersField(rule.allDestCustomers, resultObj, rule.destCustomers, fetchedItems.customers);
    this.addAttributeField(rule.destRRAttr, resultObj, fetchedItems.prefixGroups);

    return resultObj.resultStr;
  }

  private addAttributeField(srcField, strObject, dataArray): void {
    if (Array.isArray(srcField.attributes) && srcField.attributes.length > 0) {
      strObject.resultStr += 'RR Attributes: ' + this.addRRToString(srcField.attributes) + '; ';
    }

    if (Array.isArray(srcField.attributeGroups) && srcField.attributeGroups.length > 0) {
      strObject.resultStr += 'Prefix Groups: ' + this.addAttributesGroupsToString(srcField.attributeGroups, dataArray);
    }
  }

  private addAttributesGroupsToString(idArray, dataArray): string {
    let result = '';

    idArray.forEach((id, index) => {
      if (index > 0) {
        result += ', ';
      }
      result += this.getNameById(id, dataArray);
    });

    return result;
  }

  private addRRToString(rrAttrs): string {
    const attributesObj: any = {};
    let result = '';

    rrAttrs.forEach((rrAttr) => {
      if (!attributesObj.hasOwnProperty(rrAttr.type)) {
        attributesObj[rrAttr.type] = '';
      }
      attributesObj[rrAttr.type] += rrAttr.value + ', ';
    });

    if (attributesObj.hasOwnProperty('PREFIX')) {
      result += 'Prefix: ' + this.removeLastTwoCharacters(attributesObj.PREFIX);
    }

    if (attributesObj.hasOwnProperty('HOST')) {
      result += attributesObj.hasOwnProperty('PREFIX') ? ', ' : '';
      result += 'Host: ' + this.removeLastTwoCharacters(attributesObj.HOST);
    }

    return result;
  }

  private addField(srcField, strObject, strFieldName, dataArray): void {
    if (Array.isArray(srcField) && srcField.length > 0) {
      strObject.resultStr += strFieldName + ': ' + this.buildStringObject(srcField, dataArray) + '; ';
    }
  }

  private buildStringObject(idArray, fetchedItems): string {
    let resultString = '';

    idArray.forEach((id) => {
      const resultObj = fetchedItems.find((value) => {
        return value.id === id;
      });

      if (resultObj) {
        resultString += resultObj.name + ', ';
      }
    });

    return resultString.substring(0, resultString.length - 2);
  }

  private addCustomersField(allCustomers, resultObj, customersIds, customers): void {
    if (allCustomers) {
      resultObj.resultStr += 'All customers;';
      return;
    }

    this.addField(customersIds, resultObj, 'Customers', customers);
  }

  private getRuleAdvancedConditions(rule, fetchedItems): any {
    const resultObj = {resultStr: ''};

    this.addQualityField(rule.quality, resultObj);
    this.addField(rule.tbrConditionsIds, resultObj, 'Time Conditions', fetchedItems.timeConditions);
    this.addPrioritizedCallField(rule.isEmergency, resultObj);
    this.addCallTrigger(rule.isTrigger3xx, rule.isTriggerBrokenConnection, rule.isTriggerFaxRerouting,
      rule.isTriggerInitialOnly, rule.isTriggerRefer, resultObj);
    this.addEventOnMatch(rule.eventOnMatch, resultObj);

    return resultObj.resultStr;
  }

  private addQualityField(quality, resultObj): void {
    if (quality !== null) {
      let qualityString;
      if (quality === 'FAIR') {
        qualityString = 'FAIR or GOOD';
      } else {
        qualityString = 'GOOD';
      }
      resultObj.resultStr = 'Quality: use ' + qualityString + ' paths; ';
    }
  }

  private addPrioritizedCallField(prioritizedCall, resultObj): void {
    if (prioritizedCall != null && prioritizedCall === true) {
      resultObj.resultStr += 'Prioritize call;';
    }
  }

  private addCallTrigger(isTrigger3xx, isTriggerBrokenConnection, isTriggerFaxRerouting,
                         isTriggerInitialOnly, isTriggerRefer, resultObj): void {
    resultObj.resultStr += (isTrigger3xx ? '3xx;' : '') + (isTriggerInitialOnly ? 'Initial;' : '') +
      (isTriggerRefer ? 'Refer;' : '') + (isTriggerFaxRerouting ? 'Fax rerouting;' : '') +
      (isTriggerBrokenConnection ? 'Broken connection;' : '');
  }

  private getRuleAction(rule, fetchedItems): any {
    return this.buildActionsString(rule.actions, fetchedItems);
  }

  private buildActionsString(actionsArr, fetchedItems): string {
    const prioritySortedActionsArr = actionsArr.slice().sort((a, b) => a.priority - b.priority);
    const resultObj = {actionsStr: 'Actions: [ '};
    let iteration = 1;

    prioritySortedActionsArr.forEach((action) => {
      if (action.discard) {
        resultObj.actionsStr += '#' + iteration++ + ': ' + 'Discard: Yes, with SIP reason: ' + action.sipReason + ', ';
      }
      else if (action.registeredUsers){
        resultObj.actionsStr += '#' + iteration++ + ': ' + 'Registered Users: Yes , ';
      }
      else if (action.loopback){
        resultObj.actionsStr += '#' + iteration++ + ': ' + 'Loopback: Yes , ';
      }
      else if (action.continueWithNodeInternalTables){
        resultObj.actionsStr += '#' + iteration++ + ': ' + 'Continue with Node`s internal routing table: Yes , ';
      }
      else {
        resultObj.actionsStr += '#' + iteration++ + ': ';
        this.setActionField(action.nodeId, resultObj, fetchedItems.nodes.concat(fetchedItems.offlineNodes));
        this.setActionField(action.peerConnectionId, resultObj, fetchedItems.pCons.concat(fetchedItems.offlinePCons));
        this.setActionField(action.voipPeerId, resultObj, fetchedItems.voipPeers.concat(fetchedItems.offlineVoipPeers));
        this.setActionViaNodes(action.viaNodes, resultObj, fetchedItems.nodes.concat(fetchedItems.offlineNodes));
      }
    });
    return this.removeLastTwoCharacters(resultObj.actionsStr) + ']';
  }

  private setActionViaNodes(viaNodes, dstObj, fetchedItems): void {
    let nodes = '';

    if (Array.isArray(viaNodes) && viaNodes.length > 0) {
      nodes += 'via nodes: (';
      viaNodes.forEach((node) => {
        nodes += this.getNameById(node, fetchedItems) + ', ';
      });

      dstObj.actionsStr += this.removeLastTwoCharacters(nodes);
      dstObj.actionsStr += ')--';
    }
  }

  private updateContainerButtons(selected): void {
    if (Array.isArray(selected) && selected.length === 1) {
      this.hasSingleSelection = true;
      this.hasMultipleSelection = true;
      this.updatedToggleLockButtons(selected);
    } else if (Array.isArray(selected) && selected.length > 1) {
      this.hasSingleSelection = false;
      this.hasMultipleSelection = true;
      this.updatedToggleLockButtons(selected);
    } else {
      this.hasSingleSelection = false;
      this.hasMultipleSelection = false;
      this.onlyLockedItemsSelected = false;
      this.onlyUnlockedItemsSelected = false;
    }
  }

  private updatedToggleLockButtons(selection): void {
    if (Array.isArray(selection) && selection.length > 0) {
      this.onlyLockedItemsSelected = this.isAllItemsHasSameAdminState(selection, AdminStateEnum.LOCKED);
      this.onlyUnlockedItemsSelected = this.isAllItemsHasSameAdminState(selection, AdminStateEnum.UNLOCKED);

      // Both "LOCKED" and 'UNLOCKED" are selected.
      if (!this.onlyLockedItemsSelected && !this.onlyUnlockedItemsSelected) {
        this.onlyLockedItemsSelected = true;
        this.onlyUnlockedItemsSelected = true;
      }
    }
  }

  private isAllItemsHasSameAdminState(array, parameter): boolean {
    for (const item of array) {
      if (item.adminState !== parameter) {
        return false;
      }
    }
    return true;
  }

  private setActionField(srcField, dstObj, fetchedItems): void {
    if (this.isExists(srcField)) {
      dstObj.actionsStr += this.getNameById(srcField, fetchedItems) + ', ';
    }
  }

  private isExists(value): boolean {
    return !_.isNil(value) && value !== null;
  }

  private removeLastTwoCharacters(field): any {
    return field.substring(0, field.length - 2);
  }

  private addEventOnMatch(eventOnMatch, resultObj): void {
    resultObj.resultStr += eventOnMatch ? 'eventOnMatch;' : '';
  }
}
